import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalProps,
  cn,
  useModal,
} from "@nextui-org/react";
import { FC } from "react";

type DrawerPlacement = "left" | "right";

type Props = Omit<
  ModalProps,
  "fullScreen" | "closeButton" | "animated" | "blur"
  > & {
    placement?: DrawerPlacement;
  };

const Drawer: FC<Props> = ({ children, placement = "left", ...props }) => {
  const { isOpen, className } = props;

  return (
    <Modal
      className={cn(
        "fixed !m-0 top-0 h-full w-full max-w-lg rounded-none transform",
        placement === "left" ? "left-0" : "right-0",
        placement === "left"
          ? isOpen ? "animate-slide-in" : "-translate-x-full"
          : isOpen ? "animate-slide-in-right" : "translate-x-full",
        className,
      )}
      closeButton
      animated={false}
      {...props}
    >
      {children}
    </Modal>
  );
};

const useDrawer = useModal;
const DrawerHeader = ModalHeader;
const DrawerBody = ModalBody;
const DrawerFooter = ModalFooter;
const DrawerContent = ModalContent;

export {
  Drawer, DrawerBody, DrawerContent, DrawerFooter, DrawerHeader, useDrawer
};

